export const validateForm = ({ name_surname = '', email = '', phone = '', message = '' }) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const phoneRegex = /^\+?\d{8,}$/; // Requires
  const errors = {
    name_surname: '',
    email: '',
    phone: '',
    message: '',
  };

  if (!name_surname || name_surname.length < 2) {
    errors.name_surname = 'Name and surname are required and must be at least 2 characters long';
  }

  if (!emailRegex.test(email)) {
    errors.email = 'Invalid email';
  }

  if (phone !== '' && !phoneRegex.test(phone.replaceAll(' ', ''))) {
    errors.phone = "Phone number can only contain numbers and an optional '+' at the start";
  }

  if (!message) {
    errors.message = 'Message is required and must be at least 20 characters long';
  }

  return errors;
};
